import CryptoJS from "crypto-js";

export const dataEncrpt = (value) => {
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(value), process.env.REACT_APP_SECRETKEY).toString();
  } catch (error) {
    console.log("🚀 ~ file: data-encrypt.js:9 ~ dataEncrpt ~ error:", error);
  }
};